var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8AskQuestion50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VPOdc88HXLi8UTIsE~~tLa",
    x1: 12.686,
    x2: 35.58,
    y1: 4.592,
    y2: 41.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VPOdc88HXLi8UTIsE~~tLa)",
    d: "M42,8H6c-1.105,0-2,0.895-2,2v26c0,1.105,0.895,2,2,2h8v7.998 c0,0.891,1.077,1.337,1.707,0.707L24.412,38H42c1.105,0,2-0.895,2-2V10C44,8.895,43.105,8,42,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.452,12c-1.848,0-4.147,0.935-5.167,1.395c-0.326,0.147-0.53,0.469-0.53,0.826v4.551 c0,0.574,0.671,0.881,1.104,0.505c0.957-0.831,2.45-1.821,4.131-1.821c0.495,0,1.085,0.156,1.085,0.899 c0,1.961-3.945,2.66-3.945,6.821c0,0.548,0.259,1.506,0.434,2.089c0.088,0.293,0.356,0.495,0.663,0.494l4.304-0.011 c0.495-0.001,0.838-0.528,0.598-0.961c-0.273-0.492-0.377-1.018-0.377-1.214c0-0.792,0.388-1.335,1.411-2.202 c1.301-1.103,3.083-2.613,3.083-5.597C30.245,14.159,27.706,12,23.452,12z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.646,13.732c0.897-0.443,2.781-1.232,4.806-1.232c4.987,0,6.293,3.046,6.293,5.276 c0,2.734-1.593,4.102-2.879,5.192c-0.848,0.719-1.424,1.257-1.64,1.971c-0.079,0.261-0.06,0.715,0.109,1.144 c0.204,0.516,0.745,1.173-0.529,1.173l-3.283,0.005c-0.332,0-0.524-0.187-0.577-0.37c-0.103-0.353-0.231-0.883-0.278-1.38 c-0.022-0.235-0.03-0.456-0.019-0.648c0.221-3.694,3.926-4.187,3.926-6.507c0-0.692-0.413-0.97-0.809-1.124 c-0.595-0.233-1.284-0.19-1.668-0.099c-0.933,0.222-1.773,0.599-2.423,1.027c-0.451,0.297-0.987,0.271-1.149,0.101 c-0.114,0.083-0.272-0.509-0.272-0.65v-3.127c0-0.06,0.016-0.245,0.033-0.3C18.346,13.995,18.46,13.824,18.646,13.732z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.332,28.026c-1.57,0-3.24,1.043-3.24,2.975c0,1.948,1.67,2.999,3.24,2.999 c1.887,0,3.204-1.233,3.204-2.999C26.536,29.048,24.924,28.026,23.332,28.026z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.332,33.5c-1.33,0-2.74-0.865-2.74-2.499c0-1.626,1.433-2.475,2.74-2.475 c1.318,0,2.704,0.803,2.704,2.475C26.036,32.579,24.82,33.5,23.332,33.5z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.407,26.761c-0.088-0.229-0.277-0.91-0.277-1.583c0-3.832,3.945-3.979,3.945-6.821 c0-1.789-1.768-1.9-2.085-1.9c-2.008,0-3.576,1.148-4.235,1.728v-3.971C19.433,13.809,20.982,13,23.452,13 c5.72,0,5.792,3.932,5.792,4.776c0,4.539-4.684,4.875-4.684,7.784c0,0.607,0.22,1.051,0.317,1.201H21.407z M23.332,33 c-1.089,0-2.24-0.679-2.24-1.999c0-1.32,1.196-1.975,2.24-1.975c1.044,0,2.204,0.585,2.204,1.975 C25.536,32.391,24.421,33,23.332,33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AskQuestion50);
export default __webpack_public_path__ + "static/media/icons8-ask-question-50.97a6d6d873e06b328841cae8f62d01b3.svg";
export { ForwardRef as ReactComponent };